var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollButton",style:(("transform: rotate(" + _vm.degs + "deg)")),on:{"click":function($event){return _vm.action()}}})}
var staticRenderFns = []

export { render, staticRenderFns }